<template>
  <div class="menu-item button mt-5" @click="path!= '' && goTo(path)">
    {{ label }}
  </div>
</template>

<script>
import goTo from "../../mixins/goTo";
export default {
  props: {
    path: {
      // type: String,
      default: "/",
    },
    label: {
      type: String,
      default: "",
    },
  },
  mixins: [goTo],
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/variables.scss";
.menu-item {
  font-weight: 400 !important;
  cursor: pointer;
  letter-spacing: 0.15px !important;
}
.menu-item:hover {
  text-decoration: underline;
}
</style>
